import React, {useState} from 'react';
import Popup from '../../index';
import {useDispatch} from 'react-redux';
import {isConfirmSwitchToFreePopupShown} from '../../../../../actions/popupActions';
import Button from '../../../button';
import {postSwitchToFree} from '../../../../../actions/profileActions';
import Icon from '../../../icon';
import {useTranslation} from "react-i18next";

function ConfirmSwitchToFreePopup () {

	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const { t } = useTranslation();

	const dispatch = useDispatch();

	const handleSwitchToFree = () => {
		setLoading(true);
		setError(null);
		Promise.resolve(dispatch(postSwitchToFree())).catch((err) => {
			const status = err && err.response && err.response.status;
			const body = err && err.response && err.response.data;
			setLoading(false);
			setError(
				status === 403
					? t('switchToFreeForbiddenError', {
						defaultValue: 'Not allowed to switch to Free Edition. Only an App Administrator can manage billing.'
					})
					: (typeof body === 'string' && body) || t('switchToFreeGenericError', {
						defaultValue: 'Could not switch to Free Edition. Please try again or contact support.'
					})
			);
		});
	};

	return (
		<Popup className="p-4" onClose={() => dispatch(isConfirmSwitchToFreePopupShown(false))}>
			<h2>{t('confirmSwitchToFreePopupTitle')}</h2>
			<p>{t('confirmSwitchToFreePopupContent')}</p>
			{error && <p className="text-danger mt-2">{error}</p>}
			<div className="text-right">
				{
					loading
					?
						<Button disabled={true} className="btn-primary">
							<Icon animated={'pulse'} name="spinner"/>
						</Button>
					:
						<>
							<Button onClick={ handleSwitchToFree } className="btn-outline-primary mr-3">{t('yesText')}</Button>
							<Button onClick={() => dispatch(isConfirmSwitchToFreePopupShown(false))} className="btn-primary">{t('noText')}</Button>
						</>
				}
			</div>
		</Popup>
	)
}

export default ConfirmSwitchToFreePopup;
